export default __webpack_public_path__ + "static/media/scratch-half.678e75d3.png";